import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const DataIOAutomatedProcesses = () => {
	return <PlaceholderView pageType={PageType.DataIOAutomatedProcesses} text="Automated processes" />;
};

export default DataIOAutomatedProcesses;
